import React, { useState } from "react";
import styled from "styled-components";
import { SlArrowRight } from "react-icons/sl";
import Popup from "./Popup";

const Button = styled.button`
  background: white;
  border: 1.7px dashed black;
  border-radius: 20px;
  padding: 10px 15px 10px 15px;
  width: 300px;
  margin-left: 10px;
  cursor: pointer;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between; /* makes space between text and icon */
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  transition: all 100ms ease;

  &:hover {
    transform: scale(1.01);
  }
`;

const ListItem = ({ title, text, thumbnail, technologies, link }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button onClick={() => setIsOpen(true)}>
        {title}
        <SlArrowRight />
      </Button>
      {isOpen && (
        <Popup
          title={title}
          text={text}
          thumbnail={thumbnail}
          technologies={technologies}
          link={link}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  );
};

export default ListItem;
